import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import RouterBreadcrumbs from '../common/BreadCrumbs';
import { Grid } from '@material-ui/core';
import { setResultsPageSearchTerm, resetResultsViewData } from '../../redux/actions/resultsActions';
import { useParams } from 'react-router-dom';
import Search from './Search';
import AssetGrid from './AssetDataGrid';
import ProductDataGrid from './ProductDataGrid';
import { makeStyles } from '@material-ui/core/styles';
import { isEmpty, isNil } from 'lodash';
import { openBackdropOverlay } from '../../redux/actions/apiStatusActions';

const useStyles = makeStyles((theme) => ({
	root: {
		minWidth: '90em',
		marginLeft: '-8em',
	},
}));

const Results = () => {
	const dispatch = useDispatch();
	const classes = useStyles();

	/*
	getting search term from url params, and making API call on component load.
	user can bookmark the search results URL with the search term param.
	when user visit's bookmarked URL. this page loads the data for the search term.
	 */

	let { searchTerm } = useParams();
	// decode param when reading back from URL.
	searchTerm = decodeURIComponent(searchTerm ?? '');
	useEffect(() => {
		if (!isEmpty(searchTerm) && !isNil(searchTerm)) {
			dispatch(setResultsPageSearchTerm(searchTerm));
			dispatch(openBackdropOverlay(''));
		} else {
			dispatch(resetResultsViewData());
			dispatch(setResultsPageSearchTerm(''));
		}
	}, [searchTerm, dispatch]);

	//rendering all modular sections of the components
	return (
		<Grid container direction="row" className={classes.root}>
			<RouterBreadcrumbs />
			<Grid container spacing={2}>
				<Search />
				<Grid item xs={12}>
					<AssetGrid searchTerm={searchTerm} />
				</Grid>
				<Grid item xs={12}>
					<ProductDataGrid searchTerm={searchTerm} />
				</Grid>
			</Grid>
		</Grid>
	);
};

export default Results;
